import React from "react";
import { useNavigate } from "react-router-dom";
import { VehicleFormLayout } from "./components/form";

const VehicleCreatePage: React.FC = () => {
  const navigate = useNavigate();
  
  return (
    <VehicleFormLayout
      mode="create"
      title="Create New Vehicle"
      onSuccess={() => navigate("/vehicles")}
    />
  );
};

export default VehicleCreatePage;
